import React, { useState, useEffect } from 'react';
import ISO1 from '../pngs/iso-1.png';
// import ISO2 from '../pngs/iso-2.png';
import companyLogo from '../pngs/hd-logo.png';
import India from '../pngs/india.png';
import Usa from '../pngs/usa.png';
import Canada from '../pngs/canada (2).png';
import { Link } from "react-router-dom";
// import facebook from '../assets/svgs/Group 44.svg'
// import linkedin from '../assets/svgs/Group 48.svg'
// import instagram from '../assets/svgs/Group 49.svg'
// import twitter from '../assets/svgs/Group 50.svg'
import facebook from '../assets/facebook-icon.png'
import linkedin from '../assets/linkedin.png'
import instagram from '../assets/instagram-icon.png'
import twitter from '../assets/twitter.png'
import ConsultWithOmkatech from '../components/ConsultWithOmkatech'
import '../components-css/footer.scss';
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const [selectedFlag, setSelectedFlag] = useState('usa'); // click (permanent)
  const [hoveredFlag, setHoveredFlag] = useState(null); const [openLegal, setOpenLegal] = useState(false)
  const navigate = useNavigate();

  const handleMouseEnter = (flag) => {
    setHoveredFlag(flag);
  };

  const handleMouseLeave = () => {
    setHoveredFlag(null);
  };

  const handleClick = (flag) => {
    setSelectedFlag(flag);
  };

  const activeFlag = hoveredFlag || selectedFlag;

  const redirectToHomePage = () => {
    navigate('/');
  };

  return (
    <div className="footer-main-container">
      <div className='bg-img'>
        <ConsultWithOmkatech />
        <div className="middle-footer-part">
          <div className='about-company'>
            <img src={companyLogo} onClick={redirectToHomePage} alt="company-logo" />
            <p>Omka Tech offers AI-powered IT solutions, including Website Design, Development, Mobile Apps, SEO, UI/UX services, and Digital Marketing</p>
            {/* ✅ Contact Info Added Here */}
            <p className="footer-contact">
              <a href="tel:+919717511913" className="contact-link">
                📞 +91 9717511913 
              </a>
              {" | "}
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=info@omkatech.com"
                target="_blank"
                rel="noopener noreferrer"
                className="email-link"
              >
                ✉️ info@omkatech.com
              </a>

            </p>
          </div>
          <div className="country">
            <img
              src={India}
              alt="india-flag"
              className={activeFlag === 'india' ? 'flag-hovered' : ''}
              onMouseEnter={() => handleMouseEnter('india')}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleClick('india')}
            />

            <img
              src={Usa}
              alt="usa-flag"
              className={activeFlag === 'usa' ? 'flag-hovered' : ''}
              onMouseEnter={() => handleMouseEnter('usa')}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleClick('usa')}
            />

            <img
              src={Canada}
              alt="canada-flag"
              className={activeFlag === 'canada' ? 'flag-hovered' : ''}
              onMouseEnter={() => handleMouseEnter('canada')}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleClick('canada')}
            />

            <div className="text">
              {activeFlag === 'india' && <span>Jav Tower, India</span>}
              {activeFlag === 'usa' && <span>Dallas, TX, USA</span>}
              {activeFlag === 'canada' && <span>Mississauga, ON, Canada</span>}
            </div>
          </div>
          <div className="iso">
            <img onClick={() => { navigate(`/certifications/`) }} src={ISO1} alt="iso-icon" />
            {/* <img onClick={() => { navigate(`/certifications/`) }} src={ISO2} alt="iso-icon" /> */}
          </div>
          <div className="statutory-info">
            {/* <p>Statutory legal information</p> */}
            <p>
              <a href="https://www.facebook.com/omkatech" target='blank'><img src={facebook} alt="facebook-icon" /></a>
              <a href="https://www.linkedin.com/company/omkatech/" target='blank'><img src={linkedin} alt="linkedin-icon" /></a>
              <a href="https://www.instagram.com/omkatech" target='blank'><img src={instagram} alt="instagram-icon" /></a>
              <a href="https://twitter.com/omka_tech" target='blank'><img src={twitter} alt="twitter-icon" /></a>
            </p>
          </div>
        </div>
      </div>
      <div className="bottom-footer-part">

        <div className='statutory'>
          <p onClick={() => setOpenLegal(!openLegal)}>
            Statutory legal information
          </p>

          {openLegal && (
            <span>
              OMKA TECH is the Registered Name of OMKA TECH LLP, a Web/Mobile App Development company situated in Noida, U.P., India at the street address - JAV Tower, Sector 63, Noida, U.P., 201301.
              <br /><br />
              At Omka Tech, we value your privacy. So, any personal information you share with us—such as your name, email, phone number, and project details—is kept strictly confidential. We never sell, share, or rent your data to third parties. Your information is used solely by our sales and development teams to keep you informed about our latest updates or to get in touch when necessary or upon your request. You may opt out of receiving our communication by dropping us an email at - admin@omkatech.com
            </span>
          )}
        </div>

        <p>
          2026 (c) Omka Tech | 
          <Link className='link' to="sitemap"><span>Sitemap | </span></Link>
          <Link className='link' to="/privacy-policy">Privacy Policy | </Link>
          <Link className='link' to="/terms-&-conditions">Terms & Conditions | </Link>
          <Link className='link' to="/anti-spam-policy">Anti spam policy</Link>
        </p>

        <div>

          {/* Social Icons */}
          <p className='none'>
            <a href="https://www.facebook.com/omkatech" target='_blank' rel="noopener noreferrer">
              <img src={facebook} alt="facebook-icon" />
            </a>
            <a href="https://www.linkedin.com/company/omkatech/" target='_blank' rel="noopener noreferrer">
              <img src={linkedin} alt="linkedin-icon" />
            </a>
            <a href="https://www.instagram.com/omkatech" target='_blank' rel="noopener noreferrer">
              <img src={instagram} alt="instagram-icon" />
            </a>
            <a href="https://twitter.com/omka_tech" target='_blank' rel="noopener noreferrer">
              <img src={twitter} alt="twitter-icon" />
            </a>
          </p>
        </div>

      </div>

    </div>
  );
}

export default Footer;
